export const GOV_SANDBOX_ENVIRONMENT = 'govgecko-sandbox'
export const GOV_STAGING_ENVIRONMENT = 'govgecko-staging'
export const GOV_PROD_ENVIRONMENT = 'govgecko-prod'
export const UNNPI_STAGING_ENVIRONMENT = 'unnpi-staging'
export const UNNPI_PROD_ENVIRONMENT = 'unnpi-prod'
export const ADNOC_STAGING_ENVIRONMENT = 'adnoc-staging'
export const ADNOC_NPD_ENVIRONMENT = 'adnoc-npd'
export const ADNOC_PRD_ENVIRONMENT = 'adnoc-prd'
